var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemperature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.686,
    height: 34.09,
    viewBox: "0 0 31.686 34.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9056",
    "data-name": "Group 9056",
    transform: "translate(2 0.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361",
    transform: "translate(0 11.252)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 23.303,
    height: 14.252,
    rx: 0.774,
    transform: "translate(2.166 6.317)",
    fill: "#7fc2f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M3851.355,319.957h-.053a2.164,2.164,0,0,0-2.164,2.165v16.239a2.166,2.166,0,0,1-2.166,2.166H3828a2.165,2.165,0,0,1-2.165-2.166V322.122a2.165,2.165,0,0,0-2.166-2.165h0",
    transform: "translate(-3823.669 -319.957)",
    fill: "none",
    stroke: "#acffe1",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(8.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M3831.983,321.736c0-2.606-.012-5.211,0-7.816a2.846,2.846,0,0,1,2.56-2.861,2.8,2.8,0,0,1,2.952,1.963,4.967,4.967,0,0,1,.163,1.382q.016,7.479,0,14.959a1.308,1.308,0,0,0,.4,1.015,4.553,4.553,0,0,1-.1,6.374,4.508,4.508,0,0,1-6.42-6.327,1.446,1.446,0,0,0,.443-1.119C3831.973,326.783,3831.983,324.259,3831.983,321.736Zm.991.3c0,2.6-.007,5.21.008,7.814a1.084,1.084,0,0,1-.426.98,3.33,3.33,0,0,0-1.281,2.78,3.571,3.571,0,0,0,2.88,3.409,3.632,3.632,0,0,0,3.907-1.969,3.428,3.428,0,0,0-.9-4.243,1.116,1.116,0,0,1-.443-.976c.014-5.271,0-10.541.014-15.813a1.841,1.841,0,0,0-1.14-1.845,1.882,1.882,0,0,0-2.614,1.866C3832.965,316.708,3832.975,319.375,3832.975,322.04Z",
    transform: "translate(-3830.289 -311.037)",
    fill: "#acffe1",
    stroke: "#acffe1",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M3833.546,323.456q0-2.717,0-5.435a2.844,2.844,0,0,1,.043-.605.787.787,0,0,1,.825-.666.744.744,0,0,1,.827.652,9.6,9.6,0,0,1,.061,1.4q.006,5.069,0,10.138a.888.888,0,0,0,.484.923,2.5,2.5,0,0,1,1.11,2.9,2.575,2.575,0,0,1-4.944-.049,2.488,2.488,0,0,1,1.149-2.889.8.8,0,0,0,.457-.814C3833.535,327.162,3833.546,325.309,3833.546,323.456Z",
    transform: "translate(-3829.881 -309.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M3837.771,322.744l2.962-.621a.257.257,0,0,0-.008-.5l-2.978-.535a.846.846,0,0,0-1,.833h0A.846.846,0,0,0,3837.771,322.744Z",
    transform: "translate(-3828.599 -308.414)",
    fill: "#acffe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M3837.771,317.879l2.962-.621a.257.257,0,0,0-.008-.5l-2.978-.534a.845.845,0,0,0-1,.831h0A.845.845,0,0,0,3837.771,317.879Z",
    transform: "translate(-3828.599 -309.685)",
    fill: "#acffe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M3837.771,315.447l2.962-.621a.257.257,0,0,0-.008-.5l-2.978-.535a.846.846,0,0,0-1,.833h0A.845.845,0,0,0,3837.771,315.447Z",
    transform: "translate(-3828.599 -310.321)",
    fill: "#acffe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M3837.771,320.312l2.962-.621a.257.257,0,0,0-.008-.5l-2.978-.535a.846.846,0,0,0-1,.832h0A.846.846,0,0,0,3837.771,320.312Z",
    transform: "translate(-3828.599 -309.05)",
    fill: "#acffe1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/Temperature.3f40d8ecdf54c6ddbae9fd0b473d1870.svg";
export { ForwardRef as ReactComponent };